import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { generalService } from '../../../services/general.service';
import { cuentaBancaria } from '../../../models/cuentaBancaria';
import { MatOptionSelectionChange, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ItemSubFamily } from '../../../models/item-subfamily';
import { MatSelect } from '@angular/material/select';

@Component({
    selector: 'app-add-cuentaBancaria',
    templateUrl: 'cuentaBancaria-agregar.component.html',
    styleUrls: [],
    providers: [generalService]
  })

  export class CuentaBancariaAddEditComponent implements OnInit {
    private cuentaBancaria :cuentaBancaria = new cuentaBancaria();;
    public title = '';
    private arrayFiltered = undefined;
    private filteredItemsShow = 10;
    private isFiltered = false;
    private itemsShow = 10;
    public viewDataCuentas: any[];
    private BANK_ACCOUNT_ID = undefined;
    public dataConciliacionBancaria: any[] = [];
    public bancos: any[] = [];
    public cuentas: any[] = [];
    public cuentasOcupadas: any[] = [];
    public cuentaBancariaForm: FormGroup;
    public btnStatus = "";
    public nombreConciliacionTxt = "";
    public registroBaja:boolean;
    

    constructor(private router: Router,private formBuilder: FormBuilder,
      private _generalService: generalService,private route: ActivatedRoute,) {
      
      this.cuentaBancariaForm = new FormGroup({});
      this.BANK_ACCOUNT_ID = this.route.snapshot.paramMap.get('id'); 
    }

    ngOnInit(){
      this.validateRoute();
      this.buildConciliacionForm();
      this.consultarDataConciliacionBancaria();
    }

    validateRoute() {
      if (this.BANK_ACCOUNT_ID === 'N') {
        this.title = 'guardado';
        this.btnStatus = "Agregar";
      }else{
        this.title = 'actualizado';
        this.btnStatus = "Actualizar";
      }
    }

    backward() {
      this.router.navigate(['app/cuentaBancaria']);
    }

    buildConciliacionForm(){
      this.cuentaBancariaForm = this.formBuilder.group({
        BancoControl: this.formBuilder.control(null, [Validators.required, Validators.maxLength(16)]),
        ClabeControl: this.formBuilder.control(null, [Validators.required]),
        CuentaControl: this.formBuilder.control(null, [Validators.required]),
        NombreControl: this.formBuilder.control(null, [Validators.required, Validators.maxLength(45)]),
        TitularControl: this.formBuilder.control(null, [ Validators.maxLength(100)]),
        NumeroCuentaControl: this.formBuilder.control(null, [ Validators.maxLength(100)]),
        NumeroTarjetaControl: this.formBuilder.control(null, [ Validators.maxLength(100)]),
        
      });
    }

    consultarDataConciliacionBancaria(){
      let metodo = 'cuentaBancaria/getDataCunetaBancaria';
     
      const params = { 
          loacs: sessionStorage.getItem('acslo'),
          BANK_ACCOUNT_ID:this.BANK_ACCOUNT_ID
      };

      this._generalService.metodoCallParams(params, metodo).subscribe(
        result => {
          const tableResult = JSON.parse(result);
          if (tableResult && tableResult.Table){
            this.bancos = tableResult.Table; 
            this.cuentas = tableResult.Table1; 
            //this.cuentas = this.cuentas.filter(cuenta => cuenta.ACCOUNT_STATUS_ID !== 2);
            this.viewDataCuentas =this.cuentas.filter(cuenta => cuenta.ACCOUNT_STATUS_ID !== 2);
            this.dataConciliacionBancaria =  tableResult.Table2; 
            this.cuentasOcupadas = tableResult.Table3; 

            if (this.dataConciliacionBancaria.length > 0){
              //let filteredCuentas = this.cuentas.filter(cuenta => cuenta.ACCOUNT_STATUS_ID === 1);
              const selectedAccountId = this.dataConciliacionBancaria[0].ACCOUNT_ID;
              const cuentaWithStatus2 = this.cuentas.find(cuenta => 
                cuenta.ACCOUNT_ID === selectedAccountId && cuenta.ACCOUNT_STATUS_ID === 2
              );
          

              if (cuentaWithStatus2) {
                this.cuentas.push(cuentaWithStatus2);
                this._generalService.toastCall('Cambiar Cuenta');
              }
          
              this.viewDataCuentas =  this.cuentas;
             

              this.cuentaBancariaForm.get('NombreControl').setValue(this.dataConciliacionBancaria[0].NAME);
              this.cuentaBancariaForm.get('BancoControl').setValue(this.dataConciliacionBancaria[0].BANK_ID);
              this.cuentaBancariaForm.get('CuentaControl').setValue(this.dataConciliacionBancaria[0].ACCOUNT_ID);
              this.cuentaBancariaForm.get('ClabeControl').setValue(this.dataConciliacionBancaria[0].CLABE);
              this.cuentaBancariaForm.get('TitularControl').setValue(this.dataConciliacionBancaria[0].HOLDER);
              this.cuentaBancariaForm.get('NumeroCuentaControl').setValue(this.dataConciliacionBancaria[0].ACCCOUNT_NUMBER);
              this.cuentaBancariaForm.get('NumeroTarjetaControl').setValue(this.dataConciliacionBancaria[0].CARD_NUMBER);
              this.nombreConciliacionTxt = this.dataConciliacionBancaria[0].NAME;

              if(this.dataConciliacionBancaria[0].DISABLE_BY !== 0){
                this.cuentaBancariaForm.controls['NombreControl'].disable();
                this.cuentaBancariaForm.controls['ClabeControl'].disable();
                this.cuentaBancariaForm.controls['BancoControl'].disable();
                this.cuentaBancariaForm.controls['TitularControl'].disable();
                this.cuentaBancariaForm.controls['NumeroTarjetaControl'].disable();
                this.cuentaBancariaForm.controls['NumeroCuentaControl'].disable();
                this.registroBaja = true;
              }
            } 
          }
        },
        error => {  console.log(<any>error);  }
      );
    }
    isAccountDisabled(accountId: number): boolean {
      return this.cuentasOcupadas.some(cuenta => cuenta.ACCOUNT_ID === accountId);
    }
   
    mapearDatosFormularioEnModelo() {
      this.cuentaBancaria.NAME = this.cuentaBancariaForm.controls['NombreControl'].value;
      this.cuentaBancaria.CLABE = this.cuentaBancariaForm.controls['ClabeControl'].value;
      this.cuentaBancaria.ACCOUNT_ID = this.cuentaBancariaForm.controls['CuentaControl'].value;
      this.cuentaBancaria.BANK_ID = this.cuentaBancariaForm.controls['BancoControl'].value;

      this.cuentaBancaria.HOLDER = this.cuentaBancariaForm.controls['TitularControl'].value;
      this.cuentaBancaria.ACCCOUNT_NUMBER = this.cuentaBancariaForm.controls['NumeroCuentaControl'].value;
      this.cuentaBancaria.CARD_NUMBER = this.cuentaBancariaForm.controls['NumeroTarjetaControl'].value;

      this.cuentaBancaria.BANK_ACCOUNT_ID = this.BANK_ACCOUNT_ID;
      this.cuentaBancaria.loacs =  sessionStorage.getItem('acslo');
    }

    guardarConciliacion(){
      this.mapearDatosFormularioEnModelo();
      this.agregarConciliacionBancaria();
    }

    agregarConciliacionBancaria() {
      this._generalService.metodoCallParams(this.cuentaBancaria, 'cuentaBancaria/addEditCuenta').subscribe(
        (result) => {
          this.backward();
          this._generalService.toastCall('Registro '+ this.title +' exitosamente!');
          }, (error) => {
            console.log(error as any);
          });
    }
   
    onKeyUpProd(val: any) {
      let arr: any[];
      if (val.currentTarget.value != "") {
        this.arrayFiltered = this.cuentas.filter((obj) => {
          return obj.NAME.toLowerCase().indexOf(val.currentTarget.value.toLowerCase()) > -1;
        })

        arr = this.arrayFiltered.slice(0, this.filteredItemsShow);
        this.isFiltered = true;
      } else {
        /***************************INFINITE SELECT**********************************/
        // arr = this.filtroSATCodes;
        this.isFiltered = false;
        this.filteredItemsShow = 10;
        this.arrayFiltered = undefined;
        arr = this.cuentas.slice(0, this.itemsShow);
        /***************************INFINITE SELECT**********************************/
      }
      /***************************INFINITE SELECT**********************************/
      
          this.viewDataCuentas = arr;
      
      /***************************INFINITE SELECT**********************************/
  }
}


// WEBPACK FOOTER //
// ./src/app/Contabilidad/cuentaBancaria/agregar-editar/cuentaBancaria-agregar.component.ts